import React, { useCallback, useEffect, useState } from 'react'
import { BsFillFileEarmarkTextFill } from 'react-icons/bs'
import { FaUsers } from 'react-icons/fa'
import { MdDelete, MdEdit } from 'react-icons/md'
import { ModalTemplate } from './ModalTemplate'
import { ListGroup } from 'react-bootstrap'
import ModalShowEmployees from './ModalShowEmployees'
import { ModalEditDocuments } from './ModalEditDocuments'
import TemplatesService from '../../../../API/Documents/Template.api'

import './AdmissionDocuments.sass'
import Loading from '../../../../Components/Loading/Loading'
import { documentsTranslate } from '../../../../i18n/translatedMessages'

const AdmissionDocuments = () => {
	const [openEditModal, setOpenEditModal] = useState(false)
	const [templates, setTemplates] = useState([])
	const [showModal, setShowModal] = useState(false)
	const [modalTemplate, setModalTemplate] = useState(null)
	const [showModalEdit, setShowModalEdit] = useState(false)
	const [document, setDocument] = useState('')
	const [userId, setUserId] = useState('')
	const [isLoading, setLoading] = useState('')

	const loadTemplates = useCallback(async () => {
		try {
			setLoading(true)
			const response = await TemplatesService.getAllTemplates(JSON.parse(localStorage.getItem('user')).id)

			if (!response.hasOwnProperty('message')) {
				setTemplates(response)
			}
		} catch (err) {
			console.error(err)
		} finally {
			setLoading(false)
		}
	}, [])

	const deleteTemplate = async id => {
		try {
			setLoading(true)
			await TemplatesService.deleteTemplate(id)
		} catch (err) {
			console.error(err)
		} finally {
			loadTemplates()
			setLoading(false)
		}
	}

	const handleModalTemplate = (id, title) => {
		setOpenEditModal(true)
		setModalTemplate({
			id,
			title,
		})
	}
	const handleModalEdit = doc => {
		setShowModalEdit(true)
		setDocument(doc)
	}
	const handleModalCrear = id => {
		setShowModal(true)
		setUserId(id)
	}

	useEffect(() => {
		loadTemplates()
	}, [loadTemplates, showModal])

	return (
		<>
			<ModalTemplate setShowModal={setShowModal} showModal={showModal} userId={userId} />
			<ModalEditDocuments setShowModal={setShowModalEdit} showModal={showModalEdit} document={document} />
			{modalTemplate && <ModalShowEmployees isOpen={openEditModal} onClose={setOpenEditModal} template={modalTemplate} />}
			<div className='content mt-5 mt-lg-0'>
				<div className='admission-documents'>
					<div className='col'>
						<h3 className='fw-bold tw-mb-4'>{documentsTranslate.documentsTitle}</h3>
						{/* <div className='row header'>
							<div className='col d-flex mb-4'>
								<div className='icon'>
									<BsFillFileEarmarkTextFill size={30} />
								</div>
								<h3>{documentsTranslate.documentsTitle}</h3>
							</div>
						</div> */}
						<div className='tw-text-lg tw-mb-4 tw-pr-20'>{documentsTranslate.documentsDescription}</div>
						{isLoading ? (
							<Loading />
						) : (
							<div className='content'>
								<div className='create-template row mt-5'>
									<h5 className='col'>
										<strong>{documentsTranslate.myTemplatesTitle}</strong>
									</h5>
									<div className='col-4 d-flex justify-content-end'>
										<button
											type='button'
											className='tw-rounded-xl tw-bg-purple-500 hover:tw-bg-purple-700 tw-py-1 tw-px-2 tw-text-white border-0'
											onClick={() => handleModalCrear(JSON.parse(localStorage.getItem('user')).id)}
										>
											+ {documentsTranslate.createTemplate}
										</button>
									</div>
								</div>

								{templates.length > 0 && (
									<ListGroup className='custom-list-group mt-4'>
										{[...templates]
											.sort((a, b) => a.name.localeCompare(b.name))
											.map((template, index) => (
												<div key={template.id}>
													<ListGroup.Item className='d-flex justify-content-between align-items-center my-1'>
														<span>
															{' '}
															{index + 1} - {template.name}{' '}
														</span>
														<div>
															<button
																title='Ver Colaboardores'
																className='btn border mx-1'
																onClick={() => {
																	handleModalTemplate(template.id, template.name)
																}}
															>
																<FaUsers />
															</button>
															<button title='Editar Template' className='btn border mx-1' onClick={() => handleModalEdit(template)}>
																<MdEdit />
															</button>
															<button
																title='Borrar Template'
																className='btn btnDelete mx-1 delete'
																onClick={() => {
																	deleteTemplate(template.id)
																}}
															>
																<MdDelete />
															</button>
														</div>
													</ListGroup.Item>
												</div>
											))}
									</ListGroup>
								)}
								{templates.length === 0 && (
									<div className='empty-template mt-4'>
										<div className='p-3'>{documentsTranslate.emptyTemplate}</div>
									</div>
								)}
							</div>
						)}
					</div>
				</div>
			</div>
		</>
	)
}

export default AdmissionDocuments
